import { useEffect } from 'react';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import QuickInviteModalLoading from '../modals/QuickInviteModal/QuickInviteModalLoading';
import { trackSectionView } from '../tracking/trackingUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// TODO: handle missing `users-write` permissions
const QuickInviteModalContainer = ({
  'data-test-id': dataTestId,
  children,
  trackingName,
  onOpenComplete,
  onClose,
  hasError = false,
  isLoading = false,
  onOpenStart,
  onCloseComplete,
  rootNode
}) => {
  useEffect(() => {
    trackSectionView('view quick invite modal', trackingName);
  }, [trackingName]);

  // Clear cache and close modal if error
  if (hasError) {
    // TODO: add alert
    onClose(false);
    return null;
  }
  return /*#__PURE__*/_jsx(Modal, {
    "data-test-id": dataTestId,
    use: "conversational",
    width: 850,
    onOpenStart: onOpenStart,
    onOpenComplete: onOpenComplete,
    onCloseComplete: onCloseComplete,
    rootNode: rootNode,
    children: isLoading ? /*#__PURE__*/_jsx(QuickInviteModalLoading, {
      onClose: onClose
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        "data-test-id": "quick-invite-modal-close-button",
        onClick: () => onClose()
      }), children]
    })
  });
};
export default QuickInviteModalContainer;